import About from "./About.jsx";
import SEO from "../components/SEO.jsx";

export function API() {
    return (
        <>
            <SEO title="API - PostMgr" description="Integrate PostMgr's AI-powered social media management into your applications" url="https://postmgr.com/api" />
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">PostMgr API</h1>
                    <p className="text-xl text-gray-600">Powerful API for developers...</p>
                </div>
            </div>
        </>
    );
}

export default API;